export const EFFECT_ACTION_IDENTITY = 'MST_EFFECT_ACTION_IDENTITY';
export const EFFECT_ACTIONS_HANDLER = 'MST_EFFECT_ACTIONS_HANDLER';
